import { api } from './api';
import type {
  OrganizationListResponse,
  OrganizationResponse,
  MemberListResponse,
  MemberResponse,
  InvitationResponse,
  InvitationListResponse,
  InvitationPreviewResponse,
  AcceptInvitationResponse,
  DeleteResponse,
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
  InviteMemberRequest,
  UpdateMemberRoleRequest,
  SetProjectRoleRequest,
  ProjectRoleListResponse,
  ProjectRoleResponse,
  UpdateMfaPolicyRequest,
  MfaPolicyResponse,
} from '../types/organization';

// Organization endpoints
export const organizationApi = {
  list: () => api.get<OrganizationListResponse>('/api/organizations'),

  get: (orgId: string) => api.get<OrganizationResponse>(`/api/organizations/${orgId}`),

  create: (data: CreateOrganizationRequest) =>
    api.post<OrganizationResponse>('/api/organizations', data),

  update: (orgId: string, data: UpdateOrganizationRequest) =>
    api.put<OrganizationResponse>(`/api/organizations/${orgId}`, data),

  delete: (orgId: string) => api.delete<DeleteResponse>(`/api/organizations/${orgId}`),

  uploadLogo: (orgId: string, file: File) =>
    api.upload<OrganizationResponse>(`/api/organizations/${orgId}/logo`, file, 'logo'),

  removeLogo: (orgId: string) =>
    api.delete<OrganizationResponse>(`/api/organizations/${orgId}/logo`),

  updateMfaPolicy: (orgId: string, data: UpdateMfaPolicyRequest) =>
    api.put<MfaPolicyResponse>(`/api/organizations/${orgId}/mfa-policy`, data),
};

// Members endpoints
export const membersApi = {
  list: (orgId: string) => api.get<MemberListResponse>(`/api/organizations/${orgId}/members`),

  updateRole: (orgId: string, userId: string, data: UpdateMemberRoleRequest) =>
    api.put<MemberResponse>(`/api/organizations/${orgId}/members/${userId}`, data),

  remove: (orgId: string, userId: string) =>
    api.delete<DeleteResponse>(`/api/organizations/${orgId}/members/${userId}`),

  invite: (orgId: string, data: InviteMemberRequest) =>
    api.post<InvitationResponse>(`/api/organizations/${orgId}/members`, data),

  listProjectRoles: (orgId: string, userId: string) =>
    api.get<ProjectRoleListResponse>(`/api/organizations/${orgId}/members/${userId}/project-roles`),

  setProjectRole: (orgId: string, userId: string, scope: string, data: SetProjectRoleRequest) =>
    api.put<ProjectRoleResponse>(
      `/api/organizations/${orgId}/members/${userId}/project-roles/${scope}`,
      data
    ),

  removeProjectRole: (orgId: string, userId: string, scope: string) =>
    api.delete<DeleteResponse>(
      `/api/organizations/${orgId}/members/${userId}/project-roles/${scope}`
    ),
};

// Invitation endpoints
export const invitationsApi = {
  getPreview: (token: string) =>
    api.get<InvitationPreviewResponse>(`/api/invitations/${token}`, { skipAuth: true }),

  accept: (token: string) => api.post<AcceptInvitationResponse>(`/api/invitations/${token}/accept`),

  list: (orgId: string) =>
    api.get<InvitationListResponse>(`/api/organizations/${orgId}/invitations`),

  cancel: (orgId: string, invitationId: string) =>
    api.delete<DeleteResponse>(`/api/organizations/${orgId}/invitations/${invitationId}`),

  resend: (orgId: string, invitationId: string) =>
    api.post<InvitationResponse>(`/api/organizations/${orgId}/invitations/${invitationId}/resend`),
};
